module.exports = __webpack_public_path__ + "img/realestate_pf_overview_icon03.4473705b.svg";